import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {BroadcasterService} from "../broadcaster.service";
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class PatientService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    }
    // public getPatientAds(ptId: any): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'forms/getPatientADHistory',
    //             {sid: localStorage.getItem('token'), patientID: ptId}).subscribe({
    //             next: (res: any) => {
    //                 observer.next(res);
    //             },
    //             error: (err: any) => {
    //                 observer.error(err);
    //             }
    //         });
    //     });
    // }
  async getPatientAds(ptId: any): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'forms/getPatientADHistory',
        {sid: localStorage.getItem('token'), patientID: ptId}));
      return res;
    } catch(e) {
      throw e;
    }
  }
  async getPatientPolsts(ptId: any): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'forms/getPatientFormHistory',
        {sid: localStorage.getItem('token'), patientID: ptId}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public getPatientPolsts(ptId: any): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'forms/getPatientFormHistory',
    //             {sid: localStorage.getItem('token'), patientID: ptId}).subscribe({
    //             next: (res: any) => {
    //                 observer.next(res);
    //             },
    //             error: (err: any) => {
    //                 observer.error(err);
    //             }
    //         });
    //     });
    // }
    public searchPatient(lname:any, fname:any, mname:any, street:any, city:any, state:any, zip:any, dob:any, gender:any, phone:any, mrn:any): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'matchpatients',
                {sid: localStorage.getItem('token'), lname, fname, mname, street, city, state, zip, dob,
                    ssn: null, ins: null, gender, phone, mrn, pref_org_id: 0})
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
}
